<template>
    <div>
        <FormKit
            type="hidden"
            :name="`components[${index}][component_type]`"
            :value="component.component_type"
        />
        <FormKit
            label="Header titel"
            type="text"
            :name="`components[${index}][title]`"
            :value="modelValue.title"
            @input="(value) => update('title', value)"
        />

        <FormKitCKEditor
            label="Header beschrijving"
            :name="`components[${index}][description]`"
            :modelValue="modelValue.description ?? ''"
            @input="(value) => update('description', value)"
        />

        <FormKit
            label="Laat broodkruimels zien"
            type="checkbox"
            :name="`components[${index}][show_breadcrumbs]`"
            :value="!!modelValue.show_breadcrumbs"
            @input="(value) => update('show_breadcrumbs', value)"
        />

        <hr >

        <FormKitImage
            :value="modelValue.banner_image"
            :name="`components[${index}][banner_image]`"
            @input="(value) => update('banner_image', value)"
        />

        <FormKit
            label="Achtergrond opacity"
            type="number"
            :name="`components[${index}][banner_opacity]`"
            :value="modelValue.banner_opacity ?? 0"
            @input="(value) => update('banner_opacity', value)"
            validation="min:0|max:100"
        />

        <hr />

        <FormKit
            label="Laat knop zien"
            type="checkbox"
            :name="`components[${index}][has_button]`"
            :value="!!modelValue.has_button"
            @input="(value) => update('has_banner', value)"
        />

        <FormKit
            label="Button link"
            type="text"
            :name="`components[${index}][button_link]`"
            :value="modelValue.button_link ?? ''"
            @input="(value) => update('button_link', value)"
        />

        <FormKit
            label="Button label"
            type="text"
            :name="`components[${index}][button_label]`"
            :value="modelValue.button_label ?? ''"
            @input="(value) => update('button_label', value)"
        />
    </div>
</template>

<script>
import mixin from "../mixins/component";

export default {
    name: "PageHeader",
    mixins: [mixin],
};
</script>
